/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Build_Body_1Inputs */

const en_how_we_work_build_body_1 = /** @type {(inputs: How_We_Work_Build_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We connect the sources, define the rules and build the first working flow. Your team tries real scenarios and reviews the outputs as the system takes shape.`)
};

const lv_how_we_work_build_body_1 = /** @type {(inputs: How_We_Work_Build_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs savienojam avotus, definējam noteikumus un izveidojam pirmo strādājošo plūsmu. Jūsu komanda izmēģina reālus scenārijus un pārskata rezultātus, kamēr sistēma veidojas.`)
};

/**
* | output |
* | --- |
* | "We connect the sources, define the rules and build the first working flow. Your team tries real scenarios and reviews the outputs as the system takes shape." |
*
* @param {How_We_Work_Build_Body_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_build_body_1 = /** @type {((inputs?: How_We_Work_Build_Body_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Build_Body_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_build_body_1(inputs)
	return en_how_we_work_build_body_1(inputs)
});